// extracted by mini-css-extract-plugin
module.exports =  {"alert":"MpUpVQfmB8YUiQ3ypZV6"};